var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import WalletBar from '../../parts/WalletBar.vue';
import MessageDialog from '../../parts/MessageDialog.vue';
import PinDialog from "../../parts/PinDialog.vue";
import Theme from '../../../raccoonTheme';
import { Account, Address, EmptyMessage, PlainMessage, PublicAccount, TimeWindow, TransferTransaction, XEM } from "nem-library";
import { getDivided } from "../../../lib/numberUtils";
import { getTransactionHttp } from "../../../lib/nisUtils";
import ToolBar from "../../parts/ToolBar.vue";
import { WalletsHelper } from "../../../lib/storage";
import MessageModule from "../../mixins/MessageModule";
export default Vue.extend({
    mixins: [MessageModule],
    components: {
        ToolBar,
        WalletBar, MessageDialog, PinDialog
    },
    name: "SendConfirmation",
    data() {
        return {
            showSendCaution: true,
            sheet: true,
            styles: {
                bottomBorder: {
                    width: '100%',
                    height: '4px',
                    backgroundColor: Theme.primary
                }
            },
            showPinDialog: false,
            progress: true
        };
    },
    methods: {
        calculateFee() {
            try {
                const transaction = this.createTransaction();
                return getDivided(Math.round(transaction.fee), 6).toNumber();
            }
            catch (error) {
                return 0;
            }
        },
        createTransaction(account = null) {
            const xemName = new XEM(0).mosaicId.description();
            let message;
            const receiver = new Address(this.$store.state.receiverAddress);
            if (account == null) {
                account = Account.generateAccount('TEMP', 'TEMPORARY_PHRASE', receiver.network());
            }
            if (this.$store.state.sendMessage.length == 0) {
                message = EmptyMessage;
            }
            else if (this.$store.state.usesMessageEncryption) {
                message = account.encryptMessage(this.$store.state.sendMessage, PublicAccount.createWithPublicKey(this.$store.state.receiverPublicKey));
            }
            else {
                message = PlainMessage.create(this.$store.state.sendMessage);
            }
            if (Object.keys(this.$store.state.sendMosaics).length == 1 && xemName in this.$store.state.sendMosaics) {
                // XEM transfer
                return TransferTransaction.create(TimeWindow.createWithDeadline(), receiver, new XEM(this.$store.state.sendMosaics[xemName].amount), message);
            }
            else {
                // Mosaic transfer
                let mosaics = [];
                for (let key in this.$store.state.sendMosaics) {
                    const mosaicInfo = this.$store.state.sendMosaics[key];
                    mosaics.push(mosaicInfo);
                }
                return TransferTransaction.createWithMosaics(TimeWindow.createWithDeadline(), receiver, mosaics, message);
            }
        },
        onPassed(pin) {
            return __awaiter(this, void 0, void 0, function* () {
                let account;
                try {
                    const activeWallet = yield WalletsHelper.getActive();
                    if (!activeWallet) {
                        return;
                    }
                    const key = yield WalletsHelper.decryptKey(activeWallet.id, pin);
                    if (key == null) {
                        return;
                    }
                    account = Account.createWithPrivateKey(key);
                }
                catch (error) {
                    this.showError(error.toString());
                    return;
                }
                const transaction = this.createTransaction(account);
                const signedTransaction = account.signTransaction(transaction);
                const transactionHttp = getTransactionHttp();
                transactionHttp.announceTransaction(signedTransaction).subscribe(result => {
                    if ((result.code === 1) && (result.type === 1)) {
                        this.$router.push('/send/complete');
                    }
                    else {
                        this.showError(result.message);
                    }
                }, error => {
                    this.showError(error.toString());
                });
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/send/SendConfirmation.vue
// module id = 653
// module chunks = 1